<template>
  <div class="slaes-table table-component">
    <artisio-table :pagination="tableData.pagination" :sort="tableData.ordering" :items="tableData.rows"
                   :busy="tableData.loading" :fields="tableFields" show-toggle-columns
                   :enable-simple-search="false" :extra-data="extraData"
                   @paramsChanged="getTableData" @update-toggle-columns="updateToggleColumns"
                   @on-column-save="updateToggleColumns">

      <template slot="cell(created_at)" slot-scope="{item: report}">
        {{ report.created_at | toDateTime }}
        <action-buttons
            :view="false" :edit="false"
            @downloadClick="onDownloadClick(report)" @deleteClick="onRemoveClick(report)"
            :extraActions="[
              {
                index: 0,
                data: {
                  text: $i18n.t('Download'),
                  emitKey: 'downloadClick',
                  textClass: 'text-primary'
                },
              },
            ]"
        />
      </template>

      <template slot="cell(file_name)" slot-scope="{item: report}">
        {{ report.file_name }}
      </template>

      <template slot="cell(autogenerated)" slot-scope="{item: report}">
        {{ report.autogenerated ? $t('Yes') : $t('No') }}
      </template>

      <template slot="cell(created_by)" slot-scope="{item: report}">
        {{ report.created_by.display_name }}
      </template>

      <template slot="cell(filter_data)" slot-scope="{item: report}">
        <div v-if="report.filter_data">
          {{ report.filter_data.split(' - ')[0] | toDate}} -
          {{ report.filter_data.split(' - ')[1] | toDate}}
        </div>
      </template>

      <template slot="cell(type)" slot-scope="{item: report}">
        {{getReportTypeTranslation(report.type)}}
      </template>

    </artisio-table>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import ArtisioTable from "../../core/components/ams-table/ArtisioTable";
import ActionButtons from "@/core/components/ams-table/ActionButtons";
import {POLICE_BOOKS_TABLE_NAME} from "@/modules/constants";
import _ from "lodash";
import i18n from "@/shared/i18n";
import PoliceBookService from "@/modules/police-books/PoliceBookService";

const {mapState, mapActions} = createNamespacedHelpers('policeBooks')
export default {
  name: "PoliceBookTable",
  components: {ActionButtons, ArtisioTable},
  props: {},
  data: () => {
    return {}
  },
  computed: {
    ...mapState({
      tableData: state => state.tableData,
      toggleColumns: state => state.tableData.toggleColumns,
    }),
    tableFields() {
      return _.cloneDeep(this.toggleColumns.fields).filter(f => f.isVisible);
    },
    extraData() {
      return {
        ...this.toggleColumns,
        excludeColumns: [],
        tableName: POLICE_BOOKS_TABLE_NAME,
      }
    },
  },
  methods: {
    ...mapActions(['getTableData', 'removePoliceBookReport', 'updateToggleColumns']),
    async onDownloadClick(report) {
      const downloadUrlResponse = await PoliceBookService.getPoliceBookPDFUrl(report.uuid);
      const fileResponse = await fetch(downloadUrlResponse.body.url);

      if (!fileResponse.ok) {
        this.$errorDialog(fileResponse.data.error, i18n.t('Error during downloading the police book report'));
        return;
      }
      const blob = await fileResponse.blob();
      const link = document.createElement('a');

      link.href = URL.createObjectURL(blob);
      link.download = report.file_name;
      link.click();
    },
    onRemoveClick(report) {
      this.$confirm(
          this.$i18n.t("Are you sure you want to delete following report?"),
          this.$i18n.t('Report was successfully deleted'),
          this.removePoliceBookReport,
          report
      );
    },
    getReportTypeTranslation(type){
      if (type === 'general') return 'Registre de police general';
      if (type === 'precious_metals') return 'Registre de police métaux précieux';
      if (type === 'firearms') return 'Registre de police Armes';
      if (type === 'precious_metals/firearms') return 'Registre de police métaux précieux / Registre de police Armes';
      return ''
    }
  },
  mounted() {
    this.getTableData();
  },
}
</script>

<style scoped>
</style>

